import React from 'react'
import { isSteward } from "../../common/checkClient";
import DatePicker from "react-datepicker";
import * as Survey from "survey-react";
import SurveyJsComp from "../common/SurveyJsComp";
import DateUtil from "../../common/dateUtil";

const PreTradeFormPrivateInvestment = (props) => {

    const handleNumberFieldChange = (e, precision) => {
        if (/^\d+\.?\d{0,4}$/.test(e.target.value) || e.target.value === "") {
            props.handleChange(e);
        }
    };

    const handlePercentBox = (e) => {
        if (/^(100(\.0{0,2})?|(\d|[1-9]\d)(\.\d{0,2})?)$/.test(e.target.value) || e.target.value === "") {
            props.handleChange(e);
        }
    }

    const fileTemplate = {
        elements: [{
            "type": "file",
            "name": "attachments",
            "title": "Attach any relevant documents (such as subscription agreements)",
            "allowMultiple": true,
            "allowImagesPreview": false,
            "maxSize": 0
        }],
        showQuestionNumbers: "off"
    };

    const file = new Survey.Model(fileTemplate);
    const handleFileUpload = (data) => {
        if (data.attachments) {
            data.attachments = data.attachments.map(x => (
                {
                    ...x,
                    fileName: x.name,
                    mimeType: x.type
                })
            );
        }
        props.handleAttachmentChange(data.attachments);
    }

    return (
        <div className='form-items'>

            <div className='form-columns'>
                <div className='form-column'>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.businessName ? "" : "warning"}`} htmlFor="businessName">
                            Name of the Private Investment :
                        </label>
                        <input className="form-item-value" type="text" id="businessName" name="businessName" maxLength="250" value={props.data.businessName} onChange={props.handleChange} />
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.businessDesc ? "" : "warning"}`} htmlFor="businessDesc">
                            Description of the business (what services or product it provides or produces, how will it structured, it's location etc.) :
                        </label>
                        <input className="form-item-value" type="text" id="businessDesc" name="businessDesc" maxLength="250" value={props.data.businessDesc} onChange={props.handleChange} />
                    </div>

                    <div className='form-item'>
                        <label className={`form-item-label required ${props.validation.dollarAmount ? "" : "warning"}`} htmlFor="dollarAmount">
                            Amount to be invested :
                        </label>
                        <input className="form-item-value" type="text" id="dollarAmount" name="dollarAmount" value={props.data.dollarAmount} onChange={e => handleNumberFieldChange(e, 4)} />

                    </div>

                    {isSteward() &&
                        <div className='form-item'>
                            <label className={`form-item-label required ${props.validation.ownershipShares ? "" : "warning"}`} htmlFor="ownershipShares">
                                What is the number of unit/shares that you own or will own? :
                            </label>
                            <input className="form-item-value" type="text" id="ownershipShares" name="ownershipShares" value={props.data.ownershipShares} onChange={e => handleNumberFieldChange(e)} />
                        </div>
                    }

                    {isSteward() && props.data.ownershipShares &&
                        <div className="form-item">
                            <label className={`form-item-label required ${props.validation.isOwnershipBeneficial ? "" : "warning"}`}>
                                Does this make you a 25% or greater holder of the company?
                            </label>
                            <div className="form-item-value label-group">
                                <label>
                                    <input type="radio" name="isOwnershipBeneficial" value="Yes" className="form-check-input" checked={props.data.isOwnershipBeneficial === "Yes"} onChange={props.handleChange} />
                                    Yes
                                </label>
                                <label>
                                    <input type="radio" name="isOwnershipBeneficial" value="No" className="form-check-input" checked={props.data.isOwnershipBeneficial === "No"} onChange={props.handleChange} />
                                    No
                                </label>
                            </div>
                        </div>
                    }

                    {!isSteward() &&
                        <div className='form-item'>
                            <label className={`form-item-label required ${props.validation.ownershipPercent ? "" : "warning"}`} htmlFor="ownershipPercent">
                                What will be your percentage ownership in the business? :
                            </label>
                            <input className="form-item-value" type="text" id="ownershipPercent" name="ownershipPercent" value={props.data.ownershipPercent} onChange={e => handlePercentBox(e)} />
                        </div>
                    }

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.tradeDate ? "" : "warning"}`} htmlFor="tradeDate">
                            Intended Purchase Date :
                        </label>
                        <div className="form-item-value">
                            <DatePicker selected={DateUtil.toDate(props.data.tradeDate)} onChange={props.handleDateChange} />
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.isPassiveInvestor ? "" : "warning"}`}>
                            Are you a passive investor :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="isPassiveInvestor" value="Yes" className="form-check-input" checked={props.data.isPassiveInvestor === "Yes"} onChange={props.handleChange} />
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="isPassiveInvestor" value="No" className="form-check-input" checked={props.data.isPassiveInvestor === "No"} onChange={props.handleChange} />
                                No
                            </label>
                        </div>
                    </div>

                    {props.data.isPassiveInvestor === 'Yes' &&
                        <div className='form-item'>
                            <label className={`form-item-label required ${props.validation.passiveInvolvement ? "" : "warning"}`} htmlFor="passiveInvolvement">
                                Please describe your involvement as a passive investor :
                            </label>
                            <input className="form-item-value" type="text" id="passiveInvolvement" name="passiveInvolvement" maxLength="250" value={props.data.passiveInvolvement} onChange={props.handleChange} />
                        </div>
                    }


                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.isClientInvolve ? "" : "warning"}`}>
                            Are any of your current clients, or any other individuals associated with you involved in this business opportunity? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="isClientInvolve" value="Yes" className="form-check-input" checked={props.data.isClientInvolve === "Yes"} onChange={props.handleChange} />
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="isClientInvolve" value="No" className="form-check-input" checked={props.data.isClientInvolve === "No"} onChange={props.handleChange} />
                                No
                            </label>
                        </div>
                    </div>

                    {props.data.isClientInvolve === 'Yes' &&
                        <div className='form-item'>
                            <label className={`form-item-label required ${props.validation.clientInvolvement ? "" : "warning"}`} htmlFor="clientInvolvement">
                                If yes, please describe your associations :
                            </label>
                            <input className="form-item-value" type="text" id="clientInvolvement" name="clientInvolvement" maxLength="250" value={props.data.clientInvolvement} onChange={props.handleChange} />
                        </div>
                    }


                    <div className='form-item'>
                        <label className={`form-item-label required ${props.validation.businessKnowledgeSource ? "" : "warning"}`} htmlFor="businessKnowledgeSource">
                            How did you become aware of this business opportunity :
                        </label>
                        <input className="form-item-value" type="text" id="businessKnowledgeSource" name="businessKnowledgeSource" maxLength="250" value={props.data.businessKnowledgeSource} onChange={props.handleChange} />

                    </div>


                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.isPublicBusiness ? "" : "warning"}`}>
                            Is the business publicly traded? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="isPublicBusiness" value="Yes" className="form-check-input" checked={props.data.isPublicBusiness === "Yes"} onChange={props.handleChange} />
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="isPublicBusiness" value="No" className="form-check-input" checked={props.data.isPublicBusiness === "No"} onChange={props.handleChange} />
                                No
                            </label>
                        </div>
                    </div>

                    {props.data.isPublicBusiness === 'Yes' &&
                        <div className='form-item'>
                            <label className={`form-item-label required ${props.validation.publicTradeEntity ? "" : "warning"}`} htmlFor="publicTradeEntity">
                                If yes, please list information about the publicly traded entity :
                            </label>
                            <input className="form-item-value" type="text" id="publicTradeEntity" name="publicTradeEntity" maxLength="250" value={props.data.publicTradeEntity} onChange={props.handleChange} />
                        </div>
                    }


                    {!isSteward() &&
                        <div className="form-item">
                            <label className={`form-item-label required ${props.validation.isCapitalRaise ? "" : "warning"}`}>
                                Did you or do you anticipate raising capital or assisting in raising capital for this business? :
                            </label>
                            <div className="form-item-value label-group">
                                <label>
                                    <input type="radio" name="isCapitalRaise" value="Yes" className="form-check-input" checked={props.data.isCapitalRaise === "Yes"} onChange={props.handleChange} />
                                    Yes
                                </label>
                                <label>
                                    <input type="radio" name="isCapitalRaise" value="No" className="form-check-input" checked={props.data.isCapitalRaise === "No"} onChange={props.handleChange} />
                                    No
                                </label>
                            </div>
                        </div>
                    }

                    {props.data.isCapitalRaise === 'Yes' &&
                        <div className='form-item'>
                            <label className={`form-item-label required ${props.validation.capitalRaiseDesc ? "" : "warning"}`} htmlFor="capitalRaiseDesc">
                                If yes, please describe :
                            </label>
                            <input className="form-item-value" type="text" id="capitalRaiseDesc" name="capitalRaiseDesc" maxLength="250" value={props.data.capitalRaiseDesc} onChange={props.handleChange} />
                        </div>
                    }

                    {!isSteward() &&
                        <div className="form-item">
                            <label className={`form-item-label required ${props.validation.compensationMethod ? "" : "warning"}`} htmlFor="compensationMethod">
                                How will you (or any related parties) be compensated (either direct or indirectly)? :
                            </label>
                            <input className="form-item-value" type="text" id="compensationMethod" name="compensationMethod" maxLength="250" value={props.data.compensationMethod} onChange={props.handleChange} />
                        </div>
                    }

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.custodiedInvestment ? "" : "warning"}`} htmlFor="custodiedInvestment">
                            Where will the investment or its assets be custodied? :
                        </label>
                        <input className="form-item-value" type="text" id="custodiedInvestment" name="custodiedInvestment" maxLength="250" value={props.data.custodiedInvestment} onChange={props.handleChange} />
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.isBusinessCustody ? "" : "warning"}`}>
                            Do you have custody or control over the funds for this business? (e.g., trustee powers, check writing authority/check signing authority, treasurer position, etc.) :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="isBusinessCustody" value="Yes" className="form-check-input" checked={props.data.isBusinessCustody === "Yes"} onChange={props.handleChange} />
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="isBusinessCustody" value="No" className="form-check-input" checked={props.data.isBusinessCustody === "No"} onChange={props.handleChange} />
                                No
                            </label>
                        </div>
                    </div>
                    {props.data.isBusinessCustody === 'Yes' &&
                        <div className='form-item'>
                            <label className={`form-item-label required ${props.validation.businessCustody ? "" : "warning"}`} htmlFor="businessCustody">
                                If yes, what is your role or responsibility :
                            </label>
                            <input className="form-item-value" type="text" id="businessCustody" name="businessCustody" maxLength="250" value={props.data.businessCustody} onChange={props.handleChange} />
                        </div>
                    }
                    <div className="form-item">
                          <label className="form-item-label" htmlFor="attachment">Attachment Document :</label>
                          <div className="form-item-value">
                            <div className="placeholder">
                                <input type="file" name="attachment" id="attachment" onChange={props.handleChange}/>
                            </div>
                          </div>
                    </div>
                </div>

            </div>



        </div>
    )
};

export default PreTradeFormPrivateInvestment;